import "./edit-registration.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import FormRegistration from "../form-registration/form-registration";
import { useEditRegistration } from "./edit-registration.hook";

export function EditRegistration() {
  const {
    registrationData,
    isLoading,
    registrationError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditRegistration();

  const title = registrationData?.first_name ? (
    <h1>
      {registrationData?.first_name} {registrationData?.last_name}
    </h1>
  ) : (
    <h1>Edit Patient</h1>
  );

  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1  gap-2 mb-4">
        <FormRegistration isEdit={true} />
      </section>
    </div>
  );

  return (
    <div id="EditRegistration" className="registration">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {registrationError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditRegistration;
